import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { initialStatus, Status } from '../../../../status.interface';
import * as actions from './actions';
import { HostedContentFilterPolicy } from './model';

export const featureKey = 'exoHostedContentFilterPolicy';
export interface State extends EntityState<HostedContentFilterPolicy>, Status {}

export const adapter: EntityAdapter<HostedContentFilterPolicy> = createEntityAdapter<HostedContentFilterPolicy>({
    selectId: (entity) => entity.Name,
});

export const initialState: State = adapter.getInitialState({
    ...initialStatus,
});

export const reducer = createReducer(
    initialState,
    on(actions.fetchHostedContentFilterPolicySuccess, (state, action) =>
        adapter.setAll(action.data, { ...state, loaded: true }),
    ),
    on(actions.fetchHostedContentFilterPolicyFailure, (state, { error }) => ({ ...state, error })),

    on(actions.updateExoHostedContentFilterPolicy, (state) => ({ ...state, updating: true })),
    on(actions.updateExoHostedContentFilterPolicySuccess, (state, action) =>
        adapter.upsertOne(action.data, { ...state, updating: false }),
    ),
    on(actions.updateExoHostedContentFilterPolicyFailure, (state, { error }) => ({
        ...state,
        updating: false,
        error,
    })),
);

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
